import { useEffect, useState } from 'react';

import Loading from 'uI/Loading/Loading';
import UserBookCard from './UserBookCard/UserBookCard';

import { getMyBooks } from 'store/campus-actions';

import classes from './MyBooks.module.css';

const MyBooks = () => {
  const [books, setBooks] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    (async () => {
      setBooks(await getMyBooks());
      setLoad(false);
    })();
  }, []);

  return (
    <>
      {!load ? (
        <>
          <p className={classes.title}>Mis Academias</p>
          <div className={classes.booksContainer}>
            <ul className={classes.listBooks}>
              {books.map(book => (
                <li
                  key={book.idCourse}
                  className={classes.bookContainer}
                >
                  <UserBookCard book={book} />
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default MyBooks;
